@import '@radix-ui/colors/black-alpha.css';

.DialogOverlay {
  background-color: var(--black-a7);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1;
}

.DialogContent {
  background-color: white;
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  z-index: 10;
}

.DialogLeft {
  border-radius: 0px 15px 15px 0px;
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(0%, -50%);
  width: 90vw;
  max-width: 450px;
  max-height: 100vh;
  height: 100vh;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.DialogRight {
  border-radius: 15px 0px 0px 15px;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(0%, -50%);
  width: 90vw;
  max-width: 450px;
  max-height: 100vh;
  height: 100vh;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.DialogCenter {
  border-radius: 15px 15px 15px 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70vw;
  max-height: 93vh;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.DialogTop {
  border-radius: 0px 0px 15px 15px;
  position: absolute;
  top: 0%;
  left: 0%;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}

.DialogBottom {
  border-radius: 15px 15px 0px 0px;
  position: absolute;
  bottom: 0%;
  left: 0%;
  max-height: 100vh;
  width: 100vw;
  max-width: 100vw;
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: none;
}

.DialogContent:focus {
  outline: none;
}

@keyframes overlayShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes contentShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
